import React, { FC } from "react"
import { Divider, Flex, Group, Text } from "@mantine/core"
import { IconChevronDown, IconCircleX } from "@tabler/icons-react"

import TransparentButton from "../../../../components/inputs/transparent-button/TransparentButton"

type FilteringButtonProps = {
    label: string
    filterValue: string | string[] | null
    clear: () => void
}

const FilteringButton: FC<FilteringButtonProps> = ({ label, filterValue, clear }) => (
    <TransparentButton
        variant="outline"
        rightIcon={
            filterValue ? (
                <Flex
                    onClick={event => {
                        event.stopPropagation()
                        clear()
                    }}
                >
                    <IconCircleX size={26} stroke={1.5} />
                </Flex>
            ) : (
                <IconChevronDown size={26} stroke={1.5} />
            )
        }
        data-active={!!filterValue}
    >
        <Text size="sm" weight={500} sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
            <Group spacing="0.5rem">
                {label}
                {filterValue && (
                    <>
                        <Divider orientation="vertical" />
                        <Text weight={400}>{Array.isArray(filterValue) ? filterValue.join(", ") : filterValue}</Text>
                    </>
                )}
            </Group>
        </Text>
    </TransparentButton>
)

export default FilteringButton
